import Vue from 'vue'

Vue.prototype.isContains=function(word,arry) {
    const list=arry?arry:[];
    return list.some((item,i)=>{
        if(item == word){
            return true
        }
    })
};


export default {
    alert(titles, msg, type){
        Vue.prototype.$message ({
            showClose: true,
            message: msg,
            type: type,
            duration:3000
        })
    },
    loadings(n) {
        Vue.prototype.$loading({
            lock: true,
            text: '',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.4)',
            target: document.querySelector('body')
        });
        if(n == 2) {
            var loading = Vue.prototype.$loading({});
            loading.close()
        }
    },
    isJSON(str){
        if (typeof str == 'string') {
            try {
                const obj=JSON.parse(str);
                if(typeof obj == 'object' && obj ){
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                return false;
            }
        }
    },
    _isMobile() {
        const flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
    },
    isEmail(str) {
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        return reg.test(str)
    },
    // 格式化时间 时分秒分开（用）
    timestampToTime(timestamp) {
        let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + ' ';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
        let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + '/';
        //let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
        let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
        if(H -12 <0){ 
            H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' AM'; 
        }else if(H-12>0 && H-24<0){ 
            H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM'; 
        }else if(H-24 ==0){ 
            H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM'; 
        }else if(H-12==0){
            H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + 'PM';
        }
        // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
        return H+' '+D+M+Y;
    },
    formatNumber(s) {
        if (s.length == 10) {
            return s.slice(0, 4) + ' ' + s.slice(4, 7) + ' ' + s.slice(7, 10)
        } else if (s.length == 9) {
            s = '0' + s 
            return s.slice(0, 4) + ' ' + s.slice(4, 7) + ' ' + s.slice(7, 10)
        } else {
            return s
        }
    },
    // 格式化时间 时分秒分开（用）
    timestampToDate(timestamp) {
        if (typeof(timestamp) === 'string')
            timestamp = Number(timestamp)
        timestamp = timestamp < 10000000000 ? timestamp * 1000 : timestamp
        let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + ' ';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
        let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + '/';
        // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
        return D+M+Y;
    },
    formatdate (date) {
        if(!date){
            return 'select time'
        }
        date = new Date(date)
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        if (m == 1) {
            m = 'Jan'
        } else if (m == 2) {
            m = 'Feb'
        } else if (m == 3) {
            m = 'Mar'
        } else if (m == 4) {
            m = 'Apr'
        } else if (m == 5) {
            m = 'May'
        } else if (m == 6){
            m = 'June'
        } else if (m == 7) {
            m = 'July'
        } else if (m == 8) {
            m = 'Aug'
        } else if (m == 9) {
            m = 'Sept'
        } else if (m == 10) {
            m = 'Oct'
        } else if (m == 11) {
            m = 'Nov'
        } else {
            m = 'Dec'
        }
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return d + ' ' + m + ' ' + y;
    },
    formatdateminute (date) {
        if(!date){
            return 'select time'
        }
        date = new Date(date)
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        if (m == 1) {
            m = 'Jan'
        } else if (m == 2) {
            m = 'Feb'
        } else if (m == 3) {
            m = 'Mar'
        } else if (m == 4) {
            m = 'Apr'
        } else if (m == 5) {
            m = 'May'
        } else if (m == 6){
            m = 'June'
        } else if (m == 7) {
            m = 'July'
        } else if (m == 8) {
            m = 'Aug'
        } else if (m == 9) {
            m = 'Sept'
        } else if (m == 10) {
            m = 'Oct'
        } else if (m == 11) {
            m = 'Nov'
        } else {
            m = 'Dec'
        }
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
    
        var h = date.getHours()
        var minute = date.getMinutes()
        minute = minute < 10 ? ('0' + minute) : minute;
        if(h < 13) {
          h = h < 10 ? ('0' + h) + ':' + minute + ' AM' : h + ':' + minute + ' AM'
        } else {
          h = h - 12
          h = h < 10 ? ('0' + h) + ':' + minute + ' PM' : h + ':' + minute + ' PM'
        }
    
        return d + ' ' + m + ' ' + y + ' | ' + h;
    },
    formatdmy (date) {
        date = new Date(date)
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return d + '/' + m + '/' + y;
    },
    formatSplit (s) {
        if (s== 0) {
          return "0.00";
        }
        if (!s) {
          return null
        }
        if (s == null || s == "") {
          return '';
        }
        s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
        s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
        s = s.replace(".", ",");
        var re = /(\d)(\d{3},)/;
        while (re.test(s))
          s = s.replace(re, "$1,$2");
        s = s.replace(/,(\d\d)$/, ".$1");

        return s;
    },
}


// WEBPACK FOOTER //
// ./src/utils/utils.js